import * as React from "react";
import Box from "@mui/material/Box";
import ViewProgrammeDescriptor from "./ViewProgrammeDescriptor";


const ProgrammeDescriptorHome = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <ViewProgrammeDescriptor />
    </Box>
  );
};

export default ProgrammeDescriptorHome;